import React from 'react';
import { Box, Typography } from '@material-ui/core';

export default () => (
  <Box py={4} mt={2} bgcolor="primary.main">
    <Typography align="center">
      Ce site n'est pas affilié avec Niantic, Inc et Nintendo Co., Ltd, TPCi
    </Typography>
  </Box>
);